// extracted by mini-css-extract-plugin
export default {"card__container":"style_card__container__WHwe-","tag":"style_tag__1VJlp","list__container":"style_list__container__qvLtk"};